export default __webpack_public_path__ + "static/media/Total-Sks.4ab24d69.svg";